import { ChevronLeft } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { LinkPaymentStatus } from "../../Models/LinkPaymentStatus";
import { PaymentType } from "../../Models/PaymentType";
import { getRemoteValue } from "../../Utils/firebase";

const BulkPaymentStateModal = ({ type, paymentState, handleGoBack }: { type: PaymentType, paymentState: LinkPaymentStatus, handleGoBack: () => void }) => {

    const getFailMessage = () => {
        if (type === PaymentType.ALL || type === PaymentType.LATE || type === PaymentType.CUSTOM) {
            return getRemoteValue("bulk_pay_failed_message");
        } else if (type === PaymentType.SINGLE) {
            return getRemoteValue("single_pay_failed_message");
        } else if (type === PaymentType.SNOOZE) {
            return getRemoteValue("snooze_failed_message");
        }
    }
    const getSuccessMessage = () => {
        if (type === PaymentType.ALL || type === PaymentType.LATE || type === PaymentType.CUSTOM) {
            return getRemoteValue("bulk_pay_success_message");
        } else if (type === PaymentType.SINGLE) {
            return getRemoteValue("single_pay_success_message");
        } else if (type === PaymentType.SNOOZE) {
            return getRemoteValue("snooze_success_message");
        }
    }
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            paddingTop: "20px"
        }}>


            <img className="w-16 h-16" src={paymentState === LinkPaymentStatus.PAID ? '/icons/success-icon.svg' : '/icons/error-icon.svg'} alt="success" />

            <Typography variant="h5" fontSize="1.6rem" fontWeight={600} className="pt-4">
                {paymentState === LinkPaymentStatus.PAID ? getSuccessMessage() : getFailMessage()}
            </Typography>

            <Button
                onClick={() => {
                    handleGoBack();
                }}
                startIcon={<ChevronLeft />}
                sx={{
                    pt: 2,
                    color: '#191B1E',
                    textTransform: 'none',
                    fontSize: '16px',
                    fontWeight: 500,
                    '&:hover': {
                        backgroundColor: 'rgba(25, 27, 30, 0.04)',
                    },
                    pl: 1
                }}
            >
                {getRemoteValue("go_back")}
            </Button>
        </Box>
    );
};

export default BulkPaymentStateModal;